// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reimbursement-container {
  width: 95%;
  margin: 3%;
  border-radius: 10px;
}

.reimbursement-table-scroll {
  margin-top: 2%;
  height: 400px;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #ddd;
  margin-bottom: 3%;
}

.rb-form-header {
  text-align: left;
  margin: 3% 0;
}

.filter-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5% 0;
}

.filter-container label {
  font-weight: bold;
  text-align: center;
}

.filter-container input {
  padding: 1% 2%;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: medium;
}

.filter-container select {
  padding: 0.9% 2%;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: medium;
}

.search-btn,
.apply-btn {
  background-color: #79c42b;
  color: white;
  border: none;
  padding: 1% 2%;
  font-size: medium;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.search-btn:hover,
.apply-btn:hover {
  background-color: #0056b3;
}

.reimbursement-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 5px;
  overflow: hidden;
}

.reimbursement-table th,
.reimbursement-table td {
  border: 2px solid #d9d9d9;
  padding: 0.5%;
  text-align: center;
}

.reimbursement-table td:nth-child(5) {
  text-align: right;
}

.reimbursement-table th {
  background-color: #f2f2f2;
}

.reimbursement-table td {
  background-color: #fff;
}

.rbcomments-column {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rbcomments-column:hover {
  white-space: normal;
  overflow-y: auto;
  text-overflow: unset;
  max-height: 500px;
}

.status {
  padding: 6px 12px;
  border-radius: 12px;
  display: inline-block;
  text-align: center;
  min-width: 100px;
}

.status.approved {
  background-color: #d7f2ce;
}

.status.rejected {
  background-color: #ffe5d2;
}

.edit-icon,
.delete-icon {
  cursor: pointer;
  margin: 0 5px;
  font-size: x-large;
}

.edit-icon:hover {
  color: #007bff;
}

.delete-icon:hover {
  color: red;
}

.rb-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.rb-modal-content {
  background: #e8e9ea;
  padding: 0%;
  width: 70%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.claim-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #00468c;
  color: #fff;
  padding: 0 2%;
}

.claim-form-title {
  color: #fff;
}

.claim-form-close {
  font-size: x-large;
}

.rb-form-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(20%, 1fr));
  gap: 3%;
  padding: 2%;
}

.rb-form1-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(20%, 1fr));
  gap: 3%;
  padding: 2%;
}
.rb-form2-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(20%, 1fr));
  gap: 3%;
  padding: 2%;
}

.claim-type {
  display: flex;
  margin: 2%;
  max-width: 100%;
  overflow-x: auto; /* Allows horizontal scrolling if needed */
  flex-wrap: wrap; /* Ensures wrapping in smaller screens */
}

.rb-tabs {
  width: 100%;
  display: flex;
  flex-wrap: wrap; /* Allows tabs to wrap if they don't fit */
  border-bottom: none;
  max-width: 100%;
  overflow: hidden;
}

.rb-tab {
  flex: 1 1; /* Ensures tabs resize proportionally */
  min-width: 120px; /* Prevents tabs from becoming too small */
  padding: 0.5%;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  background-color: #dadada;
  border-radius: 5px 5px 0 0;
  border: 1px solid #949494;
  transition: background-color 0.3s;
  text-align: center; /* Centers text */
  white-space: nowrap; /* Prevents text breaking mid-word */
}

.rb-tab.active {
  background-color: #e8e9ea;
  border-bottom: none;
}

.claim-icons {
  font-size: 20px;
}

.claim-type select {
  padding: 2%;
}

.rb-groups {
  margin-bottom: 10%;
}

.rb-groups label {
  font-weight: bold;
  margin-bottom: 5%;
}

.rb-groups input {
  padding: 2%;
  border: 1px solid #ccc;
  background-color: #fff;
  border-radius: 5px;
  width: 95%;
}

.rb-groups select {
  padding: 2%;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 99%;
}

.reimbursement-form-button {
  display: flex;
  justify-content: flex-end;
  gap: 10%;
  margin: 2% 5%;
}

.rb-submit {
  background-color: #7fbd2c;
  color: white;
  padding: 1% 6%;
  border: 1px solid #7fbd2c;
  cursor: pointer;
  border-radius: 5px;
}

.rb-close {
  color: #000;
  padding: 1% 6%;
  border: 1px solid #7fbd2c;
  cursor: pointer;
  border-radius: 5px;
}

.radio-group {
  display: flex;
  gap: 4%;
  margin-top: 5px;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 2%;
  cursor: pointer;
  font-weight: bold;
}

.sub-tabs {
  display: flex;
  gap: 2%;
  margin: 2%;
  padding: 0 2%;
  color: #000;
  font-weight: bold;
  cursor: pointer;
}

.sub-tab.active {
  color: #004dc6;
  border-bottom: 2px solid #004dc6;
}

.rb-radio {
  display: flex;
  margin: 2%;
  padding: 1%;
  font-weight: bold;
  font-size: medium;
}

.rb-radio label {
  display: flex;
  align-items: center;
  margin-right: 5%;
}

.rb-radio-options {
  display: flex;
  gap: 20px;
}

.rb-radio-options label {
  display: flex;
  align-items: center;
  gap: 5px;
}

.rb-status-label {
  padding: 6px;
  border-radius: 12px;
  display: inline-block;
  text-align: center;
  min-width: 80px;
}

.rb-approved {
  background-color: #d7f2ce;
}

.rb-rejected {
  background-color: #ffe5d2;
}

.eye-icon {
  color: #949494;
  font-size: x-large;
}

.attachments-btn {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 3%;
  width: 90px;
  border: none;
  border-radius: 50px;
  background-color: #f2f2f2;
}

.att-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.att-modal-content {
  background: #e8e9ea;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 300px;
}

.att-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5%;
  background-color: #00468c;
  color: #fff;
}

.att-close {
  font-size: xx-large;
}

.att-close-btn {
  background-color: #79c42b;
  color: white;
  border: none;
  padding: 3% 10%;
  font-size: medium;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  align-items: center;
  margin: 5%;
  margin-left: 60%;
}

.att-files {
  padding: 2%;
  margin: 2% 5%;
}

.asterisk {
  color: red;
}

.purpose-attachment {
  display: grid;
  grid-template-columns: repeat(2, minmax(20%, 1fr));
  gap: 0.1%;
}

.pa-groups {
  padding: 4%;
}

.pa-groups label {
  font-weight: bold;
  margin-bottom: 5%;
}

.pa-groups textarea {
  padding: 2%;
  border: 1px solid #ccc;
  background-color: #fff;
  border-radius: 5px;
  width: 96%;
  height: 80px;
}

.attachment-wrapper {
  display: flex;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 80px;
  width: 95%;
  padding: 2%;
}

.file-links {
  width: 80%;
  color: #00468c;
  text-decoration: none;
  font-size: 14px;
  overflow-x: auto;
  overflow-y: auto;
}

.attachment-upload {
  display: flex;
  align-items: center;
}

.hidden-file-input {
  display: none;
}

.custom-file-upload {
  background: #79c42b;
  color: #fff;
  padding: 10% 20%;
  cursor: pointer;
  border-radius: 5px;
  font-size: 16px;
  display: inline-block;
}

.error-message {
  color: red;
  font-weight: bold;
  margin-top: 10px;
}

.disabled-icon {
  color: grey;
  pointer-events: none; /* Prevents clicking */
  opacity: 0.5; /* Makes it look disabled */
}

.actions-column {
  min-width: 75px;
}

.rb-reimbursement-cards {
  display: none;
}

/* Responsive Mobile View */
@media (max-width: 768px) {
  .reimbursement-table {
    display: none;
  }

  .filter-container {
    flex-direction: column;

    margin: 4%;
    gap: 10px;
    padding: 15px;
  }
  .rb-form-header {
    margin: 8%;
  }
  .filter-container label {
    font-size: 13px;
    margin-right: 80%;
  }

  .filter-container select {
    width: 100%;
    font-size: medium;
    padding: 10px;
  }
  .filter-container input {
    width: 94%;
    font-size: medium;
    padding: 10px;
  }

  .search-btn,
  .apply-btn {
    width: 100%;
    font-size: 13px;
    padding: 12px;
  }
}

@media (max-width: 768px) {
  .reimbursement-table-wrapper {
    display: none;
  }

  .rb-reimbursement-cards {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin: 8%;
  }

  .rb-reimbursement-card {
    background: white;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
  }

  .rb-card-header {
    display: flex;
    flex-direction: column; /* Arrange items in a row */
    justify-content: space-between; /* Push items apart */
    align-items: center; /* Align items properly */
    font-weight: bold;
    border-bottom: 1px solid #ddd;
    padding-bottom: 5px;
    margin-left: 70%;
  }

  .rb-status {
    font-size: 14px;
    font-weight: bold;
    color: green; /* Change based on status */
  }

  .rb-card-body {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .rb-form-grid {
    display: flex;
    flex-direction: column;
    gap: 5px; /* Reduce gap for better UX */
  }
  .rb-form1-grid {
    display: flex;
    flex-direction: column;
    gap: 5px; /* Reduce gap for better UX */
  }
  .rb-form2-grid {
    display: flex;
    flex-direction: column;
    gap: 5px; /* Reduce gap for better UX */
  }
  .rb-form3-grid {
    display: flex;
    flex-direction: column;
    gap: 5px; /* Reduce gap for better UX */
  }
  .rb-groups {
    flex-direction: column; /* Stack elements in a column */
    align-items: stretch; /* Ensure full width */
    gap: 10px; /* Spacing between fields */
  }

  .rb-groups label {
    display: block; /* Place label above input */
    margin-bottom: 5px; /* Spacing between label and input */
    font-size: 15px;
  }

  .rb-groups input {
    width: 95%;
    padding: 10px;
  }
  .rb-groups select {
    padding: 10px;
    width: 100%; /* Make inputs/selects full width */
    display: block; /* Ensure they stack */
  }

  .hidden-file-input {
    display: none;
  }

  .purpose-attachment {
    display: flex;
    flex-direction: column !important;
    gap: 5px;
  }
  .pa-groups {
    flex-direction: column !important; /* Stack elements in a column */
    align-items: stretch; /* Ensure full width */
    gap: 10px; /* Spacing between fields */
  }

  .pa-groups label {
    display: block; /* Place label above input */
    margin-bottom: 5px; /* Spacing between label and input */
    font-size: 15px;
  }

  .pa-groups input {
    padding: 2%;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 5px;
    width: 96%;
    height: 80px;
  }
  .custom-file-upload {
    margin-left: -40px;
    padding: 10px;
  }
  .hidden-file-input {
    display: none !important;
  }

  .rb-card-body p {
    margin: 5px 0;
  }

  .rb-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .rb-card-actions {
    display: flex;
    gap: 10px;
  }

  .rb-edit-icon,
  .rb-delete-icon {
    cursor: pointer;
    font-size: 20px;
  }
}

/* Mobile View */
@media (max-width: 768px) {
  .rb-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px;
  }

  .rb-modal-content {
    width: 92%;
    max-width: 100%;
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    overflow-y: auto;
    max-height: 90vh;
  }

  .claim-form-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
    border-bottom: 1px solid #ddd;
  }

  .claim-form-title {
    font-size: 18px;
    font-weight: 600;
  }

  .claim-form-close {
    font-size: 24px;
    cursor: pointer;
    color: #fff;
  }

  .rb-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    margin-top: 12px;
  }

  .rb-tab {
    font-size: 14px;
    padding: 10px;
    border-radius: 8px;
    background: #f3f3f3;
    transition: all 0.3s ease;
  }

  .rb-tab.active {
    background: #79c42b;
    color: white;
    font-weight: 600;
  }

  .reimbursement-form {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 15px;
  }

  .reimbursement-form input {
    display: flex;
    flex-direction: column;
  }
  .reimbursement-form select {
    width: 60%;

    padding: 12px;
    font-size: 14px;
    border-radius: 6px;
    border: 1px solid #ccc;
    background: #f9f9f9;
    transition: border 0.3s ease;
  }

  .reimbursement-form input:focus {
    width: 95%;
  }
  .reimbursement-form select:focus {
    border-color: #79c42b;
    background: white;
  }

  .reimbursement-form-button {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 15px;
  }

  .rb-radio {
    padding: 0%;
    font-weight: bold;
    font-size: 20%;
  }
  .rb-radio-options {
    font-size: 20%;
  }
  .rb-radio label {
    font-size: medium;
  }

  .rb-close,
  .rb-submit {
    width: 100%;
    font-size: 14px;
    padding: 14px;

    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    align-items: stretch;
  }

  .rb-close {
    background: #ddd;
    color: #333;
  }

  .rb-submit {
    background: #79c42b;
    color: white;
  }

  .rb-close:hover {
    background: #bbb;
  }

  .rb-submit:hover {
    background: #79c42b;
  }
}

@media (max-width: 768px) {
  .sub-tabs {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    padding: 10px;
  }

  .sub-tab {
    flex: 1 1;
    max-width: 140px;
    background-color: white;
    color: black;
    padding: 12px;
    border: 2px solid #79c42b;
    border-radius: 6px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
  }

  .sub-tab.active {
    background-color: #79c42b;
    color: white;
    border-color: #79c42b;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Reimbursement/Reimbursement.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,OAAO;EACP,WAAW;AACb;AACA;EACE,aAAa;EACb,kDAAkD;EAClD,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,gBAAgB,EAAE,0CAA0C;EAC5D,eAAe,EAAE,wCAAwC;AAC3D;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe,EAAE,0CAA0C;EAC3D,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO,EAAE,uCAAuC;EAChD,gBAAgB,EAAE,0CAA0C;EAC5D,aAAa;EACb,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB,EAAE,iBAAiB;EACrC,mBAAmB,EAAE,oCAAoC;AAC3D;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,UAAU;EACV,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB,EAAE,sBAAsB;EAC5C,YAAY,EAAE,2BAA2B;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;;IAEtB,UAAU;IACV,SAAS;IACT,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB,EAAE,2BAA2B;IACnD,8BAA8B,EAAE,qBAAqB;IACrD,mBAAmB,EAAE,yBAAyB;IAC9C,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY,EAAE,2BAA2B;EAC3C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAE,6BAA6B;EACzC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAE,6BAA6B;EACzC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAE,6BAA6B;EACzC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ,EAAE,6BAA6B;EACzC;EACA;IACE,sBAAsB,EAAE,+BAA+B;IACvD,oBAAoB,EAAE,sBAAsB;IAC5C,SAAS,EAAE,2BAA2B;EACxC;;EAEA;IACE,cAAc,EAAE,4BAA4B;IAC5C,kBAAkB,EAAE,oCAAoC;IACxD,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,aAAa;IACb,WAAW,EAAE,mCAAmC;IAChD,cAAc,EAAE,sBAAsB;EACxC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,iCAAiC;IACjC,QAAQ;EACV;EACA;IACE,iCAAiC,EAAE,+BAA+B;IAClE,oBAAoB,EAAE,sBAAsB;IAC5C,SAAS,EAAE,2BAA2B;EACxC;;EAEA;IACE,cAAc,EAAE,4BAA4B;IAC5C,kBAAkB,EAAE,oCAAoC;IACxD,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;;IAEE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,UAAU;;IAEV,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,aAAa;;IAEb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;EACvB;AACF","sourcesContent":[".reimbursement-container {\n  width: 95%;\n  margin: 3%;\n  border-radius: 10px;\n}\n\n.reimbursement-table-scroll {\n  margin-top: 2%;\n  height: 400px;\n  overflow-y: auto;\n  overflow-x: auto;\n  border: 1px solid #ddd;\n  margin-bottom: 3%;\n}\n\n.rb-form-header {\n  text-align: left;\n  margin: 3% 0;\n}\n\n.filter-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 5% 0;\n}\n\n.filter-container label {\n  font-weight: bold;\n  text-align: center;\n}\n\n.filter-container input {\n  padding: 1% 2%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: medium;\n}\n\n.filter-container select {\n  padding: 0.9% 2%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: medium;\n}\n\n.search-btn,\n.apply-btn {\n  background-color: #79c42b;\n  color: white;\n  border: none;\n  padding: 1% 2%;\n  font-size: medium;\n  cursor: pointer;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.search-btn:hover,\n.apply-btn:hover {\n  background-color: #0056b3;\n}\n\n.reimbursement-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.reimbursement-table th,\n.reimbursement-table td {\n  border: 2px solid #d9d9d9;\n  padding: 0.5%;\n  text-align: center;\n}\n\n.reimbursement-table td:nth-child(5) {\n  text-align: right;\n}\n\n.reimbursement-table th {\n  background-color: #f2f2f2;\n}\n\n.reimbursement-table td {\n  background-color: #fff;\n}\n\n.rbcomments-column {\n  max-width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rbcomments-column:hover {\n  white-space: normal;\n  overflow-y: auto;\n  text-overflow: unset;\n  max-height: 500px;\n}\n\n.status {\n  padding: 6px 12px;\n  border-radius: 12px;\n  display: inline-block;\n  text-align: center;\n  min-width: 100px;\n}\n\n.status.approved {\n  background-color: #d7f2ce;\n}\n\n.status.rejected {\n  background-color: #ffe5d2;\n}\n\n.edit-icon,\n.delete-icon {\n  cursor: pointer;\n  margin: 0 5px;\n  font-size: x-large;\n}\n\n.edit-icon:hover {\n  color: #007bff;\n}\n\n.delete-icon:hover {\n  color: red;\n}\n\n.rb-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.rb-modal-content {\n  background: #e8e9ea;\n  padding: 0%;\n  width: 70%;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.claim-form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #00468c;\n  color: #fff;\n  padding: 0 2%;\n}\n\n.claim-form-title {\n  color: #fff;\n}\n\n.claim-form-close {\n  font-size: x-large;\n}\n\n.rb-form-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(20%, 1fr));\n  gap: 3%;\n  padding: 2%;\n}\n\n.rb-form1-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(20%, 1fr));\n  gap: 3%;\n  padding: 2%;\n}\n.rb-form2-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(20%, 1fr));\n  gap: 3%;\n  padding: 2%;\n}\n\n.claim-type {\n  display: flex;\n  margin: 2%;\n  max-width: 100%;\n  overflow-x: auto; /* Allows horizontal scrolling if needed */\n  flex-wrap: wrap; /* Ensures wrapping in smaller screens */\n}\n\n.rb-tabs {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap; /* Allows tabs to wrap if they don't fit */\n  border-bottom: none;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.rb-tab {\n  flex: 1; /* Ensures tabs resize proportionally */\n  min-width: 120px; /* Prevents tabs from becoming too small */\n  padding: 0.5%;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  background-color: #dadada;\n  border-radius: 5px 5px 0 0;\n  border: 1px solid #949494;\n  transition: background-color 0.3s;\n  text-align: center; /* Centers text */\n  white-space: nowrap; /* Prevents text breaking mid-word */\n}\n\n.rb-tab.active {\n  background-color: #e8e9ea;\n  border-bottom: none;\n}\n\n.claim-icons {\n  font-size: 20px;\n}\n\n.claim-type select {\n  padding: 2%;\n}\n\n.rb-groups {\n  margin-bottom: 10%;\n}\n\n.rb-groups label {\n  font-weight: bold;\n  margin-bottom: 5%;\n}\n\n.rb-groups input {\n  padding: 2%;\n  border: 1px solid #ccc;\n  background-color: #fff;\n  border-radius: 5px;\n  width: 95%;\n}\n\n.rb-groups select {\n  padding: 2%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 99%;\n}\n\n.reimbursement-form-button {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10%;\n  margin: 2% 5%;\n}\n\n.rb-submit {\n  background-color: #7fbd2c;\n  color: white;\n  padding: 1% 6%;\n  border: 1px solid #7fbd2c;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.rb-close {\n  color: #000;\n  padding: 1% 6%;\n  border: 1px solid #7fbd2c;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.radio-group {\n  display: flex;\n  gap: 4%;\n  margin-top: 5px;\n}\n\n.radio-label {\n  display: flex;\n  align-items: center;\n  gap: 2%;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.sub-tabs {\n  display: flex;\n  gap: 2%;\n  margin: 2%;\n  padding: 0 2%;\n  color: #000;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.sub-tab.active {\n  color: #004dc6;\n  border-bottom: 2px solid #004dc6;\n}\n\n.rb-radio {\n  display: flex;\n  margin: 2%;\n  padding: 1%;\n  font-weight: bold;\n  font-size: medium;\n}\n\n.rb-radio label {\n  display: flex;\n  align-items: center;\n  margin-right: 5%;\n}\n\n.rb-radio-options {\n  display: flex;\n  gap: 20px;\n}\n\n.rb-radio-options label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.rb-status-label {\n  padding: 6px;\n  border-radius: 12px;\n  display: inline-block;\n  text-align: center;\n  min-width: 80px;\n}\n\n.rb-approved {\n  background-color: #d7f2ce;\n}\n\n.rb-rejected {\n  background-color: #ffe5d2;\n}\n\n.eye-icon {\n  color: #949494;\n  font-size: x-large;\n}\n\n.attachments-btn {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 3%;\n  width: 90px;\n  border: none;\n  border-radius: 50px;\n  background-color: #f2f2f2;\n}\n\n.att-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.att-modal-content {\n  background: #e8e9ea;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  min-width: 300px;\n}\n\n.att-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 5%;\n  background-color: #00468c;\n  color: #fff;\n}\n\n.att-close {\n  font-size: xx-large;\n}\n\n.att-close-btn {\n  background-color: #79c42b;\n  color: white;\n  border: none;\n  padding: 3% 10%;\n  font-size: medium;\n  cursor: pointer;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  margin: 5%;\n  margin-left: 60%;\n}\n\n.att-files {\n  padding: 2%;\n  margin: 2% 5%;\n}\n\n.asterisk {\n  color: red;\n}\n\n.purpose-attachment {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(20%, 1fr));\n  gap: 0.1%;\n}\n\n.pa-groups {\n  padding: 4%;\n}\n\n.pa-groups label {\n  font-weight: bold;\n  margin-bottom: 5%;\n}\n\n.pa-groups textarea {\n  padding: 2%;\n  border: 1px solid #ccc;\n  background-color: #fff;\n  border-radius: 5px;\n  width: 96%;\n  height: 80px;\n}\n\n.attachment-wrapper {\n  display: flex;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  height: 80px;\n  width: 95%;\n  padding: 2%;\n}\n\n.file-links {\n  width: 80%;\n  color: #00468c;\n  text-decoration: none;\n  font-size: 14px;\n  overflow-x: auto;\n  overflow-y: auto;\n}\n\n.attachment-upload {\n  display: flex;\n  align-items: center;\n}\n\n.hidden-file-input {\n  display: none;\n}\n\n.custom-file-upload {\n  background: #79c42b;\n  color: #fff;\n  padding: 10% 20%;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 16px;\n  display: inline-block;\n}\n\n.error-message {\n  color: red;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n.disabled-icon {\n  color: grey;\n  pointer-events: none; /* Prevents clicking */\n  opacity: 0.5; /* Makes it look disabled */\n}\n\n.actions-column {\n  min-width: 75px;\n}\n\n.rb-reimbursement-cards {\n  display: none;\n}\n\n/* Responsive Mobile View */\n@media (max-width: 768px) {\n  .reimbursement-table {\n    display: none;\n  }\n\n  .filter-container {\n    flex-direction: column;\n\n    margin: 4%;\n    gap: 10px;\n    padding: 15px;\n  }\n  .rb-form-header {\n    margin: 8%;\n  }\n  .filter-container label {\n    font-size: 13px;\n    margin-right: 80%;\n  }\n\n  .filter-container select {\n    width: 100%;\n    font-size: medium;\n    padding: 10px;\n  }\n  .filter-container input {\n    width: 94%;\n    font-size: medium;\n    padding: 10px;\n  }\n\n  .search-btn,\n  .apply-btn {\n    width: 100%;\n    font-size: 13px;\n    padding: 12px;\n  }\n}\n\n@media (max-width: 768px) {\n  .reimbursement-table-wrapper {\n    display: none;\n  }\n\n  .rb-reimbursement-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin: 8%;\n  }\n\n  .rb-reimbursement-card {\n    background: white;\n    padding: 30px;\n    border-radius: 10px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n  }\n\n  .rb-card-header {\n    display: flex;\n    flex-direction: column; /* Arrange items in a row */\n    justify-content: space-between; /* Push items apart */\n    align-items: center; /* Align items properly */\n    font-weight: bold;\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 5px;\n    margin-left: 70%;\n  }\n\n  .rb-status {\n    font-size: 14px;\n    font-weight: bold;\n    color: green; /* Change based on status */\n  }\n\n  .rb-card-body {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n  }\n\n  .rb-form-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 5px; /* Reduce gap for better UX */\n  }\n  .rb-form1-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 5px; /* Reduce gap for better UX */\n  }\n  .rb-form2-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 5px; /* Reduce gap for better UX */\n  }\n  .rb-form3-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 5px; /* Reduce gap for better UX */\n  }\n  .rb-groups {\n    flex-direction: column; /* Stack elements in a column */\n    align-items: stretch; /* Ensure full width */\n    gap: 10px; /* Spacing between fields */\n  }\n\n  .rb-groups label {\n    display: block; /* Place label above input */\n    margin-bottom: 5px; /* Spacing between label and input */\n    font-size: 15px;\n  }\n\n  .rb-groups input {\n    width: 95%;\n    padding: 10px;\n  }\n  .rb-groups select {\n    padding: 10px;\n    width: 100%; /* Make inputs/selects full width */\n    display: block; /* Ensure they stack */\n  }\n\n  .hidden-file-input {\n    display: none;\n  }\n\n  .purpose-attachment {\n    display: flex;\n    flex-direction: column !important;\n    gap: 5px;\n  }\n  .pa-groups {\n    flex-direction: column !important; /* Stack elements in a column */\n    align-items: stretch; /* Ensure full width */\n    gap: 10px; /* Spacing between fields */\n  }\n\n  .pa-groups label {\n    display: block; /* Place label above input */\n    margin-bottom: 5px; /* Spacing between label and input */\n    font-size: 15px;\n  }\n\n  .pa-groups input {\n    padding: 2%;\n    border: 1px solid #ccc;\n    background-color: #fff;\n    border-radius: 5px;\n    width: 96%;\n    height: 80px;\n  }\n  .custom-file-upload {\n    margin-left: -40px;\n    padding: 10px;\n  }\n  .hidden-file-input {\n    display: none !important;\n  }\n\n  .rb-card-body p {\n    margin: 5px 0;\n  }\n\n  .rb-card-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .rb-card-actions {\n    display: flex;\n    gap: 10px;\n  }\n\n  .rb-edit-icon,\n  .rb-delete-icon {\n    cursor: pointer;\n    font-size: 20px;\n  }\n}\n\n/* Mobile View */\n@media (max-width: 768px) {\n  .rb-modal {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0px;\n  }\n\n  .rb-modal-content {\n    width: 92%;\n    max-width: 100%;\n    padding: 20px;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n    overflow-y: auto;\n    max-height: 90vh;\n  }\n\n  .claim-form-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #ddd;\n  }\n\n  .claim-form-title {\n    font-size: 18px;\n    font-weight: 600;\n  }\n\n  .claim-form-close {\n    font-size: 24px;\n    cursor: pointer;\n    color: #fff;\n  }\n\n  .rb-tabs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    justify-content: center;\n    margin-top: 12px;\n  }\n\n  .rb-tab {\n    font-size: 14px;\n    padding: 10px;\n    border-radius: 8px;\n    background: #f3f3f3;\n    transition: all 0.3s ease;\n  }\n\n  .rb-tab.active {\n    background: #79c42b;\n    color: white;\n    font-weight: 600;\n  }\n\n  .reimbursement-form {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 15px;\n  }\n\n  .reimbursement-form input {\n    display: flex;\n    flex-direction: column;\n  }\n  .reimbursement-form select {\n    width: 60%;\n\n    padding: 12px;\n    font-size: 14px;\n    border-radius: 6px;\n    border: 1px solid #ccc;\n    background: #f9f9f9;\n    transition: border 0.3s ease;\n  }\n\n  .reimbursement-form input:focus {\n    width: 95%;\n  }\n  .reimbursement-form select:focus {\n    border-color: #79c42b;\n    background: white;\n  }\n\n  .reimbursement-form-button {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 15px;\n  }\n\n  .rb-radio {\n    padding: 0%;\n    font-weight: bold;\n    font-size: 20%;\n  }\n  .rb-radio-options {\n    font-size: 20%;\n  }\n  .rb-radio label {\n    font-size: medium;\n  }\n\n  .rb-close,\n  .rb-submit {\n    width: 100%;\n    font-size: 14px;\n    padding: 14px;\n\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    align-items: stretch;\n  }\n\n  .rb-close {\n    background: #ddd;\n    color: #333;\n  }\n\n  .rb-submit {\n    background: #79c42b;\n    color: white;\n  }\n\n  .rb-close:hover {\n    background: #bbb;\n  }\n\n  .rb-submit:hover {\n    background: #79c42b;\n  }\n}\n\n@media (max-width: 768px) {\n  .sub-tabs {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 10px;\n    padding: 10px;\n  }\n\n  .sub-tab {\n    flex: 1;\n    max-width: 140px;\n    background-color: white;\n    color: black;\n    padding: 12px;\n    border: 2px solid #79c42b;\n    border-radius: 6px;\n    font-weight: bold;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n  }\n\n  .sub-tab.active {\n    background-color: #79c42b;\n    color: white;\n    border-color: #79c42b;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
